import React, { useEffect, useState } from 'react';
import { Navbar, Container, Nav, NavDropdown, Col, Row, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import useWindowDimensions from '../../helpers/GetCurrentWidth';
import { FaBars } from 'react-icons/fa';
import { ReactComponent as FlagBrazil } from '../../assets/icons/Flag-Brazil.svg';
import { ReactComponent as FlagEUA } from '../../assets/icons/Flag-EUA.svg';
import { ReactComponent as FlagMexico } from '../../assets/icons/Flag-Mexico.svg';
import { ReactComponent as UserCircle } from '../../assets/icons/user-circle.svg';
import BellNotification from './BellNotification';
import Logo from '../../assets/images/logo1.png';
import { MenuState } from '../../types';
import i18n from '../../translate/i18n';

const listLanguages = [{
  lang: 'pt-BR',
  icon: <FlagBrazil className='me-2' />,
  text: 'Português Brasil(pt-BR)'
}, {
  lang: 'en-US',
  icon: <FlagEUA className='me-2' />,
  text: 'English(en)'
}, {
  lang: 'es-ES',
  icon: <FlagMexico className='me-2' />,
  text: 'Español(es)'
}
]


const Header = (props: any) => {

  const [langSelected, setLangSelected] = useState<string>(localStorage.getItem('i18nextLng') || 'pt-BR');
  const [name, setName] = useState<string>();
  const [id, setId] = useState<string>('');
  const [showState, setShowState] = useState<MenuState | {}>(false);
  const { width } = useWindowDimensions();

  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  useEffect(() => {
    const user: any = localStorage.getItem('user');
    const { name, id } = JSON.parse(user);
    setName(name);
    setId(id);
  }, [])

  const handleMenu = () => {
    setShowState(!showState);
    props.handleMenu(!showState)
  }

  const handleSelectLanguage = (lang: string) => {
    localStorage.setItem('i18nextLng', lang);
    setLangSelected(lang);
    window.location.reload();
  }

  return (
    <Navbar id='nav-header' expand="lg" className='header-border'>
      <Container className="shadow-none">
        <Row className="justify-content-between align-items-center w-100">
          {
            width < 768 ?
              <>
                <Col xs={6} sm={6} md={6} lg={6} className="d-flex justify-content-center p-0">
                  <Link to='/home'>
                    <Image src={Logo} className="header-logo"></Image>
                  </Link>
                </Col>
                <Col xs={6} sm={6} md={6} lg={6} className="d-flex justify-content-end align-items-center p-0">
                  <FaBars onClick={() => handleMenu()}></FaBars>
                </Col>
              </>
              :
              <>
                <Col sm={8} md={8} lg={8} className=' d-flex flex-column justify-content-center align-items-start '>
                  <Navbar.Brand className="header-title ">
                    <strong>{(props.path && props.path === 'home') ? `${i18n.t<string>('header.message')}, ${name}` : `${props.path}`}</strong>
                  </Navbar.Brand>
                  <Navbar.Brand className="header-path">
                    {props.path && props.path !== 'home' && <Link to={`/home`}>{i18n.t<string>('menu.home')} / </Link>}
                    {props.path === 'Editar O.S.' && <Link to={`/lista-os`}>{i18n.t<string>('menu.processes')} / </Link>}
                    {props.path && props.path !== 'home' && props.path}
                  </Navbar.Brand>
                </Col>

                <Col sm={2} md={2} lg={2}>
                  <Nav className="mt-2">
                    {listLanguages[listLanguages.findIndex(i => i.lang === langSelected)].icon}
                    <NavDropdown title='' id="basic-nav-dropdown">
                      {listLanguages.map(i =>
                        <NavDropdown.Item
                          key={i.lang} // Adiciona a key aqui
                          onClick={() => { handleSelectLanguage(i.lang) }}>
                          {i.icon} {i.text}
                        </NavDropdown.Item>
                      )}
                    </NavDropdown>
                  </Nav>
                </Col>

                <Col sm={2} md={2} lg={2}>
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-0 ms-auto">
                      <UserCircle />
                      <NavDropdown title={name} id="basic-nav-dropdown">
                        <NavDropdown.Item href="/configuracoes">{i18n.t<string>('header.edit profile')}</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="/login" onClick={logout}>{i18n.t<string>('header.logout')}</NavDropdown.Item>
                      </NavDropdown>
                    </Nav>
                  </Navbar.Collapse>
                </Col>
              </>
          }
        </Row>
      </Container>
    </Navbar >
  )
}


export const mapStateToProps = (menuState: MenuState) => ({
  menuState
});

export default connect(mapStateToProps)(Header);